






































































































































































































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop, Watch} from 'vue-property-decorator';
import {getModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {Notify} from '@/utils/Notify';

import {AntennaType} from '@/model/lora/AntennaType';
import {Timezone} from '@/model/system/time/timezone';
import {LoraForwarder} from '@/model/lora/LoraForwarder';

import {IIdentityUserService} from '@/services/identity/IIdentityUserService';
import {ISystemTimeService} from '@/services/system/ITime.service';
import {ILoraHardwareService} from '@/services/lora/ILoraHardware.service';
import {ILoraForwardersService} from '@/services/lora/ILoraForwarders.service';

import {AuthStore} from '@/store/Auth.store';
import SystemRegionStore from '@/store/system/SystemRegion.store';
import LoraHardwareStore from '@/store/lora/LoraHardware.store';
import SystemInfoStore from '@/store/system/SystemInfo.store';
import LoraForwardersStore from '@/store/lora/LoraForwarders.store';

import {BaseComponent} from '@/mixins/BaseComponent';
import SystemPassword from '@/components/System/SystemPassword.vue';
import TimezoneEditor from '@/components/System/Region/TimezoneEditor.vue';
import LoraHardware from '@/components/Lora/LoraHardware.vue';
import LoraRegionEditor from '@/components/Lora/LoraRegionEditor.vue';
import LoraAntennaEditor from '@/components/Lora/LoraAntennaEditor.vue';
import LoraForwarderSelector from '@/components/Lora/Forwarder/LoraForwarderSelector.vue';
import ThemeSelector from '@/components/System/ThemeSelector.vue';
import LoraForwarderChirpStackInfo from '@/components/Lora/Forwarder/ChirpStack/LoraForwarderChirpStackInfo.vue';
import LoraForwarderBasicStationInfo
  from '@/components/Lora/Forwarder/BasicStation/LoraForwarderBasicStationInfo.vue';
import LoraForwarderUdpInfo from '@/components/Lora/Forwarder/Udp/LoraForwarderUdpInfo.vue';
import LoraForwarderLoriotInfo from '@/components/Lora/Forwarder/Loriot/LoraForwarderLoriotInfo.vue';

enum Step {
  Password = 1,
  Timezone,
  Lora,
  Forwarder,
  Summary,
}

@Component({
  components: {
    ThemeSelector,
    LoraForwarderSelector,
    LoraAntennaEditor, LoraRegionEditor, LoraHardware, TimezoneEditor, SystemPassword,
    LoraForwarderUdpInfo,
    LoraForwarderLoriotInfo,
    LoraForwarderChirpStackInfo,
    LoraForwarderBasicStationInfo,
  },
})
export default class SetupWizard extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('IIdentityUserService'))
  private userService!: IIdentityUserService;

  @Inject(Symbol.for('AuthStore'))
  private authStore!: AuthStore;

  @Inject(Symbol.for('ISystemTimeService'))
  private systemTimeService!: ISystemTimeService;

  @Inject(Symbol.for('ILoraHardwareService'))
  private loraHardwareService!: ILoraHardwareService;

  @Inject(Symbol.for('ILoraForwardersService'))
  private loraForwarderService!: ILoraForwardersService;

  private forwardersInfoComponent = {
    'udp-packet-forwarder': 'lora-forwarder-udp-info',
    'loriot-packet-forwarder': 'lora-forwarder-loriot-info',
    'chirpstack-gateway-bridge': 'lora-forwarder-chirp-stack-info',
    'lora-basic-station': `lora-forwarder-basic-station-info`,
  };

  private regionStore: SystemRegionStore = getModule(SystemRegionStore, this.$store);

  private loraHardwareStore: LoraHardwareStore = getModule(LoraHardwareStore, this.$store);

  private loraForwardersStore: LoraForwardersStore = getModule(LoraForwardersStore, this.$store);

  private systemInfoStore: SystemInfoStore = getModule(SystemInfoStore, this.$store);

  @Prop({default: false})
  private open!: boolean;

  private Step = Step;
  private step: Step = Step.Password;
  private lastStep = Step.Summary;

  private saving: boolean = false;

  /* SYSTEM */
  private passwordCurrent: string = 'lorix4u';

  private passwordNew: string = '';

  private formValid: boolean = false;

  private timezone: Timezone | null = null;

  /* LORA */
  private antennaType: AntennaType | null = null;

  private region: string | null = null;

  private selectedForwarder: LoraForwarder | null = null;

  private async next() {

    this.saving = true;

    try {
      switch (this.step) {
        case Step.Password:
          if (this.passwordNew !== '') {
            await this.savePassword();
          }
          break;

        case Step.Timezone:
          if (this.timezone?.Timezone !== this.regionStore.Timezone?.Timezone) {
            await this.saveTimezone();
          }
          break;

        case Step.Lora:
          await this.saveLora();
          break;

        case Step.Forwarder:
          await this.saveForwarder();
          break;
      }

      if (this.step === this.lastStep) {
        this.close();
      } else {
        this.step++;
      }
    } catch (error) {
      Notify.Error(this.logger, `Error`, error);
    } finally {
      this.saving = false;
    }
  }

  private back() {
    this.step--;
  }

  @Watch('step')
  private async onStepChanged() {
    try {
      this.setLoading();
      switch (this.step) {
        case Step.Forwarder:
          await this.loraForwardersStore.fetchActiveForwarder();
          break;

        case Step.Summary:
          await this.systemInfoStore.fetchSystemInfo();
          await this.systemInfoStore.fetchOsInfo();
          break;
      }
    } catch (error) {
      Notify.Error(this.logger, `Load error`, error);
    } finally {
      this.setLoaded();
    }
  }

  private async savePassword(): Promise<void> {
    this.logger.trace('Changing password...');
    await this.userService.setPassword(this.authStore.LoggedUsername, this.passwordCurrent, this.passwordNew);
    this.logger.info(`The password has been changed`);
  }

  private async saveTimezone(): Promise<void> {
    if (this.timezone === null) {
      this.logger.warn('Cannot save timezone, undefined');
      return;
    }

    this.logger.trace('Changing timezone...', this.timezone);
    await this.systemTimeService.setTimezone(this.timezone);
    this.regionStore.setTimezone(this.timezone);
    this.logger.info(`The timezone has been changed`, this.timezone);
  }

  private async saveLora(): Promise<void> {

    if (this.antennaType && this.antennaType !== this.loraHardwareStore.Antenna) {
      this.logger.info(`Settings LoRa antenna type to '${this.antennaType.Id}'`);
      await this.loraHardwareService.setAntennaType(this.antennaType.Id);
      this.loraHardwareStore.setAntenna(this.antennaType);
    }

    if (this.region && this.region !== this.loraHardwareStore.Region) {
      this.logger.info(`Settings LoRa region to '${this.region}'`);
      await this.loraHardwareService.setRegion(this.region);
      this.loraHardwareStore.setRegion(this.region);
    }
  }

  private async saveForwarder(): Promise<void> {

    if (!this.selectedForwarder) {
      Notify.Error(this.logger, `Could not enable forwarder`, null, ['No forwarder is selected']);
      return;
    }

    if (this.selectedForwarder.Id === this.loraForwardersStore.ActiveForwarder?.Id) {
      return;
    }

    this.saving = true;

    try {
      this.logger.info(`Settings active LoRa forwarder to:`, this.selectedForwarder);
      await this.loraForwarderService.setActive(this.selectedForwarder.Id);
      this.loraForwardersStore.setActiveForwarder(this.selectedForwarder);
    } catch (error) {
      Notify.Error(this.logger, `Could not set active LoRa forwarder`, error);
    } finally {
      this.saving = false;
    }
  }

  private async configureForwarder(): Promise<void> {
    await this.saveForwarder();
    this.$router.push({name: 'lora-settings'});
    this.close();
  }

  private close() {
    this.step = Step.Password;
    this.$emit('update:open', false);
  }
}
